const mutations = {
    setListBanks(state, list) {
        state.banks = list;
    },
    setListBranches(state, list) {
        state.branches = list;
    },
    setListNotifications(state, list) {
        state.notifications = list;
    },
    setListProposalStatus(state, list){
        state.proposal_status = list;
    },
    setListStates(state, list) {
        state.states = list;
    }
};

export default mutations;